import React, {Component} from "react";
import Button from "../../shared/components/Button";
import FieldError from "../../shared/components/forms/FieldError";
import FormError from "../../shared/components/forms/FormError";
import { CardElement, injectStripe } from 'react-stripe-elements';
import {label as textInputFieldLabelStyle} from "../../shared/components/forms/TextInputField.module.scss";
import { withTranslation, Trans } from 'react-i18next';
import styles from "./NewCreditCardForm.module.scss";

class NewCreditCardForm extends Component {

  constructor(props) {
    super(props);
    this.cardRef = React.createRef();
    this.state = { 
      errors: [],
      stripeErrorMessage: null,
      submittingToken: false,
      stripeFocused : false,
      stripeErrored : false,
    }
  }

  submit(ev) {
    this.setState({submittingToken: true});
    return this.props.stripe.confirmCardSetup(
      this.props.clientSecret, 
      {
        payment_method: {
          card: this.cardRef.current.getElement()
        }
      })
      .then((result) => {
        if (result.error) {
          this.setState({
            submittingToken: false, 
            stripeErrorMessage: result.error.message
          });
        } else {
          // Success.
          this.setState({
            submittingToken: false, 
            stripeErrorMessage: null
          });
          return this.props.onSubmit(result.setupIntent.payment_method);
        }
      })    
      .catch((error) => {
        this.setState({
          submittingToken: false, 
          stripeErrorMessage: this.props.t("credit_card.validating_error"),
        });
      });
  }

  render() {
    let {errors, submitting} = this.props;
    let active = !(submitting || this.state.submittingToken);
    let submitLabel = active ? this.props.t("credit_card.add") : this.props.t("standby");

    const stripeElementClasses = ["StripeElement"]
    if (this.state.stripeFocused) {
      stripeElementClasses.push(styles.stripeFocused);
    }
    if (this.state.stripeErrored) {
      stripeElementClasses.push(styles.stripeErrored);
    }
    
    return (
      <form className={styles.module} onSubmit={this.submit.bind(this)}>
        <div className="fields">
          <p className="u-centered">
            <Trans
              i18nKey="common:credit_card.authorize_text"
              components={{
                b: <span className="sg-font-bold"/>
              }}
              values={{
                shopName: this.props.shopName,
              }}
            />
          </p>
          {/* Fake textInputField label */}
          <div className={textInputFieldLabelStyle}>{this.props.t("credit_card.card_details")}</div>
          <CardElement ref={this.cardRef} className={stripeElementClasses.join(" ")}
            {...this.sgForStripeCardElement()} />
          <FieldError serverError={this.state.stripeErrorMessage} />
          <FormError error={errors._error} />
        </div>
        <div className="buttons">
          <Button label={submitLabel} primary={true} onClick={this.submit.bind(this)} active={active} />
          <Button label={this.props.t("cancel")} active={active} onClick={this.props.onCancel}
            theme={Button.THEMES.BLUE_OUTLINE}
            addCancelToTopRight={true} />
        </div>
      </form>
    )
  }

  // Stripe cardelement style can be customised here (cannot use vars through iframe)
  // => handle the focused and error states changes, plus some default styling
  sgForStripeCardElement() {
    return {
      onFocus: () => this.setState({ stripeFocused: true }),
      onBlur: () => this.setState({ stripeFocused: false }),
      onChange: (event) => {
        const inError = !!event.error;
        if (this.state.stripeErrored !== inError) {
          this.setState({ stripeErrored: inError });
        }
      },
      style: {
        base: {
          fontSize: "18px",
          color: "#141414", // --grey-900
          // https://github.com/stripe-archive/react-stripe-elements/issues/179
          fontFamily: '"AbelPro", Arial, sans-serif',
          "::placeholder": {
            color: "#c2c2c2", // --grey-300
          },
        },
        invalid: {
          color: "#d42b2b", // --accent-red-600
        },
      },
    }
  }
}

export default withTranslation("common")(injectStripe(NewCreditCardForm));